import {
  SHIPMENT_MANAGER_DELETE_SPLIT_FAIL,
  SHIPMENT_MANAGER_DELETE_SPLIT_REQUEST,
  SHIPMENT_MANAGER_DELETE_SPLIT_RESET,
  SHIPMENT_MANAGER_DELETE_SPLIT_SUCCESS,
  SHIPMENT_MANAGER_GROUPED_FAIL,
  SHIPMENT_MANAGER_GROUPED_REQUEST,
  SHIPMENT_MANAGER_GROUPED_RESET,
  SHIPMENT_MANAGER_GROUPED_SUCCESS,
  SHIPMENT_MANAGER_PLANNING_FAIL,
  SHIPMENT_MANAGER_PLANNING_REQUEST,
  SHIPMENT_MANAGER_PLANNING_RESET,
  SHIPMENT_MANAGER_PLANNING_SUCCESS,
  SHIPMENT_MANAGER_UPSERT_SPLIT_FAIL,
  SHIPMENT_MANAGER_UPSERT_SPLIT_REQUEST,
  SHIPMENT_MANAGER_UPSERT_SPLIT_RESET,
  SHIPMENT_MANAGER_UPSERT_SPLIT_SUCCESS
} from '@/constants/shipmentManagerConstants'

// --- Planning Data (lines, splits, summary) ---
export const shipmentManagerPlanningReducer = (state = { planning: null, summary: {}, lines: [] }, action) => {
  switch (action.type) {
    case SHIPMENT_MANAGER_PLANNING_REQUEST:
      return { ...state, loading: true, error: null }
    case SHIPMENT_MANAGER_PLANNING_SUCCESS:
      return {
        ...state,
        loading: false,
        planning: action.payload,
        summary: action.payload?.summary || {},
        lines: (action.payload?.lines || []).map((line) => ({
          ...line,
          line_item_id: line.line_item_id ?? line.id,
          splits: (line.splits || []).map((split) => ({
            ...split,
            warehouse_id: split.shipment?.warehouse_id ?? split.warehouse_id,
            warehouse: split.shipment?.warehouse ?? split.warehouse,
            ship_date: split.shipment?.ship_date ?? split.ship_date,
            transaction_type: split.shipment?.transaction_type ?? split.transaction_type ?? null,
            ext_vendor_id: split.shipment?.ext_vendor_id ?? split.ext_vendor_id,
            ext_vendor: split.shipment?.ext_vendor ?? split.ext_vendor
          }))
        }))
      }
    case SHIPMENT_MANAGER_PLANNING_FAIL:
      return { ...state, loading: false, error: action.payload }
    case SHIPMENT_MANAGER_PLANNING_RESET:
      return { planning: null, summary: {}, lines: [], loading: false, error: null }
    default:
      return state
  }
}

// --- Upsert & Delete Split Operations ---
export const shipmentManagerSplitReducer = (state = {}, action) => {
  switch (action.type) {
    case SHIPMENT_MANAGER_UPSERT_SPLIT_REQUEST:
      return { ...state, loadingUpsert: true, errorUpsert: null, successUpsert: false }
    case SHIPMENT_MANAGER_UPSERT_SPLIT_SUCCESS:
      return { ...state, loadingUpsert: false, successUpsert: true, split: action.payload }
    case SHIPMENT_MANAGER_UPSERT_SPLIT_FAIL:
      return { ...state, loadingUpsert: false, errorUpsert: action.payload }
    case SHIPMENT_MANAGER_UPSERT_SPLIT_RESET:
      return { ...state, successUpsert: false, errorUpsert: null }

    case SHIPMENT_MANAGER_DELETE_SPLIT_REQUEST:
      return { ...state, loadingDelete: true, errorDelete: null, successDelete: false }
    case SHIPMENT_MANAGER_DELETE_SPLIT_SUCCESS:
      return { ...state, loadingDelete: false, successDelete: true }
    case SHIPMENT_MANAGER_DELETE_SPLIT_FAIL:
      return { ...state, loadingDelete: false, errorDelete: action.payload }
    case SHIPMENT_MANAGER_DELETE_SPLIT_RESET:
      return { ...state, successDelete: false, errorDelete: null }

    default:
      return state
  }
}

// --- Grouped Shipment Data (Review Mode) ---
export const shipmentManagerGroupedReducer = (state = { shipments: [], default_shipment: null, summary: {} }, action) => {
  switch (action.type) {
    case SHIPMENT_MANAGER_GROUPED_REQUEST:
      return { ...state, loading: true, error: null }
    case SHIPMENT_MANAGER_GROUPED_SUCCESS:
      return {
        ...state,
        loading: false,
        shipments: action.payload?.shipments || [],
        default_shipment: action.payload?.default_shipment || null,
        summary: action.payload?.summary || {}
      }
    case SHIPMENT_MANAGER_GROUPED_FAIL:
      return { ...state, loading: false, error: action.payload }
    case SHIPMENT_MANAGER_GROUPED_RESET:
      return { shipments: [], default_shipment: null, summary: {}, loading: false, error: null }
    default:
      return state
  }
}
